import { CONFIG } from '../../../../config';
import _ from 'lodash';
import environment from '../../../environment';
import { NOTIFY_TYPE, notifyError, notifySuccess } from '../../../shared';
import AuthService from '../../../../services/authservice';
import fetch from '../../fetch';

const management = (() => {
    const update = {
        client(req) {
            if (!_.isArray(req.data.Bandeiras)) {
                req.data.Bandeiras = [req.data.Bandeiras];
            }

            return fetch({
                url: `${environment.get('API_HOST')}/Cliente/updateCliente`,
                type: 'POST',
                data: JSON.stringify(req.data),
                success: req.success,
                error: notifyError
            });
        },

        user(req) {
            return fetch({
                url: `${environment.get('API_HOST')}/Users/Atualizar`,
                type: 'PUT',
                data: JSON.stringify(req.data),
                success: req.success,
                error: notifyError
            });
        }
    };

    update.client.profile = data =>
        fetch({
            url: `${environment.get('API_HOST')}/Cliente/SaveFunctionPerfil`,
            type: 'POST',
            data: JSON.stringify(data)
        });

    update.client.user = req => {
        let env = environment.get('CONFIG');

        // O token do neodash é revogado ANTES do próprio: o IdP exige um token válido nessa chamada.
        const completed = () =>
            fetch({
                type: 'POST',
                url: `${environment.get('IDENTITY_SERVER_URL')}/accountprofile/user/${env.IDUSER}/revokeclienttoken/${CONFIG.NEODASH_CLIENT_ID}`,
                error: notifyError
            })
                .catch(() => false)
                .then(success => {
                    if (!success) console.log('Não foi possível revogar o token do neodash');

                    return AuthService.revokeAccessToken().then(() => AuthService.login());
                });
        return fetch({
            type: 'POST',
            url: `${environment.get('IDENTITY_SERVER_URL')}/accountprofile/user/changeuserclient/${env.IDUSER}/${req.clientId}/${req.vehicleTypeId}`,
            data: JSON.stringify(req.clientId),
            error: notifyError
        }).then(completed);
    };

    update.user.profile = data =>
        fetch({
            url: `${environment.get('API_HOST')}/Users/SaveFunctionPerfil`,
            type: 'POST',
            data: JSON.stringify(data)
        });

    update.user.password = req =>
        fetch({
            type: 'POST',
            url: `${environment.get('API_HOST')}/Users/AlterarSenha`,
            data: JSON.stringify(req)
        }).then(notifySuccess);

    update.user.password.forgot = req => {
        const completed = () => {
            const message = { type: NOTIFY_TYPE.SUCCESS, text: 'Solicitação de nova senha enviada com sucesso' };
            notifySuccess(message);
        };

        return fetch({
            type: 'POST',
            contentType: 'application/json; charset=UTF-8',
            url: `${environment.get('API_HOST')}/Users/ResetarSenha`,
            data: JSON.stringify(req),
            error: notifyError
        }).then(completed);
    };

    update.user.vehicleType = idVehicleType => {
        let env = environment.get('CONFIG');
        fetch({
            type: 'POST',
            contentType: 'application/json; charset=UTF-8',
            url: `${environment.get('IDENTITY_SERVER_URL')}/accountprofile/user/${
                env.IDUSER
            }/changeuservehicletype/${idVehicleType}`,
            error: notifyError
        }).then(() => {
            AuthService.revokeAccessToken().then(() => {
                AuthService.login();
            });
        });
    };

    update.user.password.token = req =>
        fetch({
            type: 'POST',
            contentType: 'application/json; charset=UTF-8',
            url: `${environment.get('API_HOST')}/Users/AlterarSenhaPorToken`,
            data: JSON.stringify(req)
            // error: notifyError
        }).then(notifySuccess);

    const add = {
        user(req) {
            return fetch({
                url: `${environment.get('API_HOST')}/Users/Cadastrar`,
                type: 'POST',
                data: JSON.stringify(req.data),
                success: req.success,
                error: notifyError
            });
        },

        client(req) {
            if (!_.isArray(req.data.Bandeiras)) {
                req.data.Bandeiras = [req.data.Bandeiras];
            }

            return fetch({
                url: `${environment.get('API_HOST')}/Cliente/createClient`,
                type: 'POST',
                data: JSON.stringify(req.data),
                error: notifyError
            });
        }
    };

    const remove = {
        user(id) {
            return fetch({
                url: `${environment.get('API_HOST')}/Users/Desativar?id=${id}`,
                type: 'DELETE'
            });
        },

        client(id) {
            return fetch({
                url: `${environment.get('API_HOST')}/Cliente/RemoveCliente`,
                type: 'GET',
                data: {
                    IdCliente: Number(id)
                }
            });
        }
    };

    const get = {
        flags(id) {
            return fetch({
                url: `${environment.get('API_HOST')}/General/ObterBandeirasHabilitadasMercado`,
                type: 'GET',
                data: {
                    IdMercado: id
                }
            });
        },

        markets() {
            return fetch({
                url: `${environment.get('API_HOST')}/General/ListaMercado`,
                type: 'GET'
            });
        },

        user(id) {
            return fetch({
                url: `${environment.get('API_HOST')}/Users/Obter?id=${id}`,
                type: 'GET'
            });
        },

        types() {
            return fetch({
                url: `${environment.get('API_HOST')}/General/ListaTipo`,
                type: 'GET'
            });
        },

        client(id) {
            return fetch({
                url: `${environment.get('API_HOST')}/Cliente/GetClient`,
                type: 'GET',
                data: {
                    idCliente: id
                }
            });
        },
    };

    get.client.users = () =>
        fetch({
            url: `${environment.get('API_HOST')}/Users/ObterPorCliente`,
            type: 'GET'
        });

    get.client.profile = id =>
        fetch({
            url: `${environment.get('API_HOST')}/Cliente/ObterPerfisList`,
            type: 'GET',
            data: {
                Id: Number(id)
            }
        });

    get.operations = (idProfile, type, idUsers) =>
        fetch({
            url: `${environment.get('API_HOST')}/${type}/ObterFuncPerfil`,
            type: 'GET',
            data: {
                idPerfil: Number(idProfile),
                IdUsuario: Number(idUsers)
            }
        });

    return {
        update,
        add,
        remove,
        get
    };
})();

export default management;



// WEBPACK FOOTER //
// ./src/scripts/api/endpoints/management/index.js